import React from 'react';
import { Instagram, Phone, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-title">Paweł Kozłowski</h3>
            <p className="footer-subtitle">Trener Personalny | Dietetyk | Doradca</p>
          </div>
          
          <div className="footer-links">
            <div className="footer-section">
              <h4 className="footer-heading">Kontakt</h4>
              <a href="tel:+48668904145" className="footer-link">
                <Phone size={16} />
                +48 668 904 145
              </a>
              <a href="mailto:pawel.kozlowski.1989@o2.pl" className="footer-link">
                <Mail size={16} />
                pawel.kozlowski.1989@o2.pl
              </a>
            </div>

            <div className="footer-section">
              <h4 className="footer-heading">Social Media</h4>
              <a 
                href="https://www.instagram.com/trener.kozlowski.89" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-link"
              >
                <Instagram size={16} />
                Instagram
              </a>
              <a 
                href="https://www.tiktok.com/@Dragon1989" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-link"
              >
                TikTok
              </a>
            </div>

            <div className="footer-section">
              <h4 className="footer-heading">Usługi</h4>
              <a href="#services" className="footer-link">Trening Personalny</a>
              <a href="#services" className="footer-link">Dietetyka</a>
              <a href="#services" className="footer-link">Treningi Online</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} IT-LIFE Karol Kos. Wszystkie prawa zastrzeżone.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
